import { render, staticRenderFns } from "./ReputationProviders.vue?vue&type=template&id=c84c45ba&scoped=true"
import script from "./ReputationProviders.vue?vue&type=script&lang=js"
export * from "./ReputationProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84c45ba",
  null
  
)

export default component.exports